"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _eventingBus = _interopRequireDefault(require("eventing-bus"));
var events = _interopRequireWildcard(require("./events/events"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
// Utility function to immutably 'update' an object
function updateObject(oldObject, newValues) {
  return Object.assign({}, oldObject, newValues);
}
function incrementAmountOfUploadsInProgress(state) {
  if (state.amountOfUploadsInProgress === 0) {
    _eventingBus["default"].publish(events.fileUploadsStart, 'fileUploadsStart');
  }
  var currentAmountOfUploads = state.amountOfUploadsInProgress + 1;
  return updateObject(state, {
    amountOfUploadsInProgress: currentAmountOfUploads
  });
}
function decrementAmountOfUploadsInProgress(state) {
  var currentAmountOfUploads = state.amountOfUploadsInProgress - 1;
  if (currentAmountOfUploads === 0) {
    _eventingBus["default"].publish(events.fileUploadsComplete, 'fileUploadsComplete');
  }
  return updateObject(state, {
    amountOfUploadsInProgress: currentAmountOfUploads
  });
}
var _default = exports["default"] = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    amountOfUploadsInProgress: 0
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;
  switch (type) {
    case 'INCREMENT_AMOUNT_OF_UPLOADS_IN_PROGRESS':
      return incrementAmountOfUploadsInProgress(state);
    case 'DECREMENT_AMOUNT_OF_UPLOADS_IN_PROGRESS':
      return decrementAmountOfUploadsInProgress(state);
    default:
      return state;
  }
};